import { render, staticRenderFns } from "./pProject.vue?vue&type=template&id=398ee170&scoped=true"
import script from "./pProject.vue?vue&type=script&lang=js"
export * from "./pProject.vue?vue&type=script&lang=js"
import style0 from "./pProject.vue?vue&type=style&index=0&id=398ee170&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398ee170",
  null
  
)

export default component.exports